import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Admin Guard - Protects the /admin route.
 * Only allows users with 'admin' role.
 * Redirects to /app if authenticated but not admin.
 * Redirects to / if not authenticated.
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const storedUser = localStorage.getItem('googleUser');
  if (!storedUser) {
    console.log('🚫 Admin Guard: User not authenticated, redirecting to login');
    router.navigate(['/']);
    return false;
  }

  try {
    const user = JSON.parse(storedUser);
    if (!user || !user.email) {
      localStorage.removeItem('googleUser');
      localStorage.removeItem('userRole');
      router.navigate(['/']);
      return false;
    }
  } catch {
    localStorage.removeItem('googleUser');
    localStorage.removeItem('userRole');
    router.navigate(['/']);
    return false;
  }

  const userRole = localStorage.getItem('userRole');
  if (userRole === 'admin') {
    return true;
  }

  console.log('🚫 Admin Guard: User is not admin (role:', userRole, '), redirecting to /app');
  router.navigate(['/app']);
  return false;
};
